// ANCHOR React
import React from 'react';

// ANCHOR Results
import { ICourseResult } from '@lyon/utils/api/results/course';
import { IModuleItemResult } from '@lyon/utils/api/results/module-item';

// ANCHOR Components
import { LyonCourseContentLayout } from '../LyonCourseContentLayout';
import { LyonCourseContentContainer } from './LyonCourseContentContainer';

interface IProps {
  id: string;
  initialData: IModuleItemResult;
  courseInitialData: ICourseResult;
}

export function LyonCourseContent({
  id,
  initialData: data,
  courseInitialData: courseData,
}: IProps) {
  return (
    <LyonCourseContentLayout
      id={id}
      initialData={data}
      courseData={courseData}
    >
      <LyonCourseContentContainer />
    </LyonCourseContentLayout>
  );
}
